import { sendExportRequest, type PerformanceFilter } from "features/Library/Common/utils/performanceUtils";
import { groupTemplateDataService } from "../../DataService/groupTemplateDataService";

export const getTemplateExport = (params: PerformanceFilter, templateId: number, templateName: string) => {
  let abortController = new AbortController();
  return sendExportRequest(
    (abortController) => groupTemplateDataService.getTemplateExport(params, templateId),
    templateName,
    abortController,
  );
};
